import {IonGrid, IonRow, IonCol, IonModal, IonButtons, IonButton, IonIcon, IonContent, IonHeader, IonToolbar, IonTitle, useIonRouter, IonList, IonItem, IonLabel, IonRadio, IonRadioGroup, IonNote} from "@ionic/react";
import {checkmarkOutline, chevronBack, scan} from "ionicons/icons";
import {QrReader} from "react-qr-reader";
import {Simulate} from "react-dom/test-utils";
import error = Simulate.error;
import {OnResultFunction} from "react-qr-reader/src/types";
import CustomField from "../components/CustomField";
import {useFormInput, validateForm} from "../_/useForms";
import {useEffect, useState} from "react";
import indexBy from "underscore/modules/indexBy";
import styles_Modal_2_1 from './Modal_2_1.module.scss';
import {push_pg_0_24__VenderRedeem} from "../store/Pg_2_Store";
import {handleCommonFetchErrors} from "./Utils";
import {Pg_8_5_Store, fetch_pg_8_5__giftoptions, push_pg_8_5__scan} from "../store/Pg_8_Store";

const GIFT_NONE = "none";
import {useStoreState} from "pullstate";
import {getPageData} from "../store/Selectors";


export const useLoginFields = (Item_會員) => {
    return [
        {
            id: "create_nickname",
            label: "暱稱",
            required: true,
            input: {
                props: {
                    type: "text",
                    placeholder: "暱稱",
                    autocomplete: "false"
                },
                state: useFormInput("")
            }
        },
        {
            id: "create_email",
            label: "Email",
            required: true,
            input: {
                props: {
                    type: "text",
                    placeholder: "Email",
                    autocomplete: "false"
                },
                state: useFormInput("")
            }
        },
        // {
        //     id: "手機國碼",
        //     label: "手機國際碼",
        //     required: true,
        //     input: {
        //         props: {
        //             type: "text",
        //             placeholder: "手機國際碼",
        //         },
        //         state: useFormInput(Item_會員.手機國碼, (val, oldVal) => {
        //
        //         })
        //     }
        // },
        // {
        //     id: "手機號碼",
        //     label: "手機號碼",
        //     required: true,
        //     input: {
        //         props: {
        //             type: "text",
        //             placeholder: "手機號碼",
        //             autocomplete: "tel-local"
        //         },
        //         state: useFormInput(Item_會員.手機, (val, oldVal) => {
        //
        //         })
        //     }
        // },
        {
            id: "create_phone",
            label: "手機號",
            required: true,
            input: {
                props: {
                    type: "text",
                    placeholder: "手機號 (台灣手機免打國際碼，開頭為0)",
                    autocomplete: "false"
                },
                state: useFormInput("")
            }
        },
        {
            id: "create_password",
            label: "密碼",
            required: false,
            input: {
                props: {
                    type: "text",
                    placeholder: "密碼 (預設 設成 '手機號' 則免填留空)",
                },
                state: useFormInput("")
            }
        },
    ];
}

export const Modal_8_5_Scan = ({Item_會員, dismiss, onResult}) => {
    const router = useIonRouter();
    let [mode, setMode] = useState(1);
    const pgData = useStoreState(Pg_8_5_Store, getPageData);

    //#region Back button
    useEffect(() => {
        let callback: any = (ev) => {
            // ev.detail.register(10, () => {
            //     console.log('Handler was called!');
            // });

            dismiss();
        };

        document.addEventListener('ionBackButton', callback);
        // Remove listener on unmount
        return () => document.removeEventListener("ionBackButton", callback);
    }, []);
    //#endregion


    const fields = useLoginFields(Item_會員);
    let keyedFields = indexBy(fields, 'id');


    const [errors, setErrors] = useState(false);

    //#region 贈品
    const [List_GiftToken, setList_GiftToken] = useState<any[] | null>(null);
    const [giftValue, setGiftValue] = useState<string>(GIFT_NONE);
    const [giftLoadFailed, setGiftLoadFailed] = useState(false);

    const loadGiftOptions = async () => {
        let result: any;
        try {
            result = await fetch_pg_8_5__giftoptions();
        } catch (err) {
            console.warn('giftoptions', err);
            setGiftLoadFailed(true);
            setGiftValue(GIFT_NONE);
            return;
        }
        setGiftLoadFailed(false);
        const {error, payload} = result;
        if (error) {
            handleCommonFetchErrors(router, error);
            return;
        }
        const list = payload?.List_GiftToken ?? [];
        setList_GiftToken(list);

        // 已選的贈品沒有剩餘數量 → 改回不贈送
        setGiftValue(v => {
            if (v === GIFT_NONE) {
                return v;
            }
            const item = list.find(t => String(t.TokenId) === v);
            return (item && item.可贈與數量 > 0) ? v : GIFT_NONE;
        });
    }

    useEffect(() => {
        loadGiftOptions();
    }, []);
    //#endregion

    const handleScan = result => {
        if (result) {
            //setQRData(result);
            //play();
            //handleSuccess(result);
            alert(`代碼: ${result.text}`);
            keyedFields.code.input.state.reset(result.text);
            //onResult(result);
        }
    }

    const _push_redeem = async () => {
        const errors = validateForm(fields);
        setErrors(errors);

        if (!errors.length) {
            const create_nickname = fields && (keyedFields.create_nickname as any).input.state.value;
            const create_email = fields && (keyedFields.create_email as any).input.state.value;
            const create_phone = fields && (keyedFields.create_phone as any).input.state.value;
            const create_password = fields && (keyedFields.create_password as any).input.state.value;

            //const 手機國碼 = fields && (keyedFields.手機國碼 as any).input.state.value;
            //const 手機號碼 = fields && (keyedFields.手機號碼 as any).input.state.value;


            const gift_tokenId = giftValue === GIFT_NONE ? null : +giftValue;

            let result: any = null;
            try {
                result = await push_pg_8_5__scan({
                    create_nickname: create_nickname,
                    create_email: create_email,
                    create_phone: create_phone,
                    create_password: create_password,
                    gift_tokenId: gift_tokenId,
                }, {silent: true});
            } catch (err) {
                // 失敗 (例如贈品已無剩餘數量) → 更新剩餘數量
                loadGiftOptions();
                throw err;
            }
            if (result.error) {
                handleCommonFetchErrors(router, result.error);
                return;
            }

            // 成功 → 關閉 drawer，由呼叫端顯示成功訊息
            const Item_GiftToken = gift_tokenId === null ? null : (List_GiftToken ?? []).find(t => t.TokenId === gift_tokenId);
            dismiss();

            if (onResult) {
                onResult(true, {
                    nickname: create_nickname,
                    phone: create_phone,
                    giftName: Item_GiftToken?.名稱 ?? null,
                    Gift_TokenEnwId: result.payload?.Gift_TokenEnwId ?? null,
                });
            }

        } else {
        }
    }


    return <>
        <IonHeader>
            <IonToolbar>
                <IonTitle>直接建立帳號</IonTitle>
                <IonButtons slot="start">
                    <IonButton onClick={dismiss}>
                        <IonIcon size="large" icon={chevronBack} style={{marginLeft: "-0.7rem"}}/>
                    </IonButton>
                </IonButtons>
            </IonToolbar>
        </IonHeader>

        <IonContent fullscreen>
            <IonGrid>
                {/*<IonRow className="ion-text-center ion-margin-top" >*/}
                {/*    <IonCol size="12">*/}
                {/*        <IonIcon style={{ fontSize: "5rem" }} icon={ props.modalOptions.icon } />*/}
                {/*    </IonCol>*/}
                {/*</IonRow>*/}
                {mode === 2 &&
                    <IonRow className="ion-justify-content-center ion-text-center">
                        <IonCol>
                            <IonButton fill={"solid"} onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();

                                setMode(1);

                                return false;
                            }}>
                                關閉掃描
                            </IonButton>
                        </IonCol>
                    </IonRow>
                }

                {mode === 2 &&
                    <div className={styles_Modal_2_1.readerContainer}>
                        <div className={styles_Modal_2_1.reader}>
                            <QrReader
                                containerStyle={{maxHeight: '350px'}}
                                constraints={{facingMode: 'environment'}}
                                scanDelay={500}
                                videoId={'video'}
                                onResult={handleScan}
                                videoStyle={{height: "350px"}}
                            />
                        </div>
                        <div className={styles_Modal_2_1.readerBg}>
                            <div className={styles_Modal_2_1.readerBgText}>若方框內為空白畫面，表示沒有權限操作相機，請手動輸入兌換碼</div>
                        </div>
                    </div>
                }

                <IonRow className="ion-justify-content-center">
                    <IonCol>

                    </IonCol>
                </IonRow>

                {/*<IonRow className="ion-justify-content-center ion-text-center ion-margin-top ">*/}
                {/*    <IonCol>*/}
                {/*        <IonButton fill={"solid"}>*/}
                {/*            兌換*/}
                {/*        </IonButton>*/}
                {/*    </IonCol>*/}
                {/*</IonRow>*/}

                <IonRow>
                    <IonCol>
                        {fields.map((f: any) => {
                            return <CustomField className={styles_Modal_2_1.marginTop} key={f.id} field={f} errors={errors} noLabelSlot={false}/>
                        })}

                        <div className={styles_Modal_2_1.marginTop}>
                            <div>贈品</div>
                            {giftLoadFailed ? <IonNote color="danger">贈品選項讀取失敗 (不贈送)</IonNote> :
                             List_GiftToken === null ? <IonNote>讀取中...</IonNote> :
                                <IonList inset={false} style={{borderRadius: "10px", marginTop: "0.25rem"}}>
                                    <IonRadioGroup value={giftValue} onIonChange={e => setGiftValue(e.detail.value)}>
                                        <IonItem>
                                            <IonLabel>不贈送</IonLabel>
                                            <IonRadio slot="end" value={GIFT_NONE}/>
                                        </IonItem>
                                        {List_GiftToken.map((Item_Token: any) => {
                                            const 可贈與數量 = Item_Token.可贈與數量 ?? 0;
                                            return <IonItem key={Item_Token.TokenId} disabled={可贈與數量 <= 0}>
                                                <IonLabel className="ion-text-wrap">
                                                    {/* 名稱最多 2 行，超過顯示 … */}
                                                    <div style={{display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden", wordBreak: "break-word"}}>
                                                        {Item_Token.名稱}
                                                    </div>
                                                    <p>TokenId {Item_Token.TokenId}</p>
                                                </IonLabel>
                                                <IonNote slot="end">剩餘 {可贈與數量}</IonNote>
                                                <IonRadio slot="end" value={String(Item_Token.TokenId)}/>
                                            </IonItem>;
                                        })}
                                    </IonRadioGroup>
                                </IonList>
                            }
                        </div>
                    </IonCol>
                </IonRow>

                <IonRow className="ion-justify-content-center ion-text-center ion-margin-top ">
                    <IonCol>
                        <IonButton fill={"solid"} onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();

                            _push_redeem();

                            return false;
                        }}>
                            確定建立
                        </IonButton>
                    </IonCol>
                </IonRow>

                {/* 底部留白，避免按鈕貼齊畫面底部 / iPhone home indicator */}
                <div style={{height: "calc(3rem + env(safe-area-inset-bottom))"}}/>

                {/*{mode === 1 &&*/}
                {/*    <IonRow className="ion-justify-content-center ion-text-center ion-margin-top ">*/}
                {/*        <IonCol>*/}
                {/*            <IonButton fill={"solid"} onClick={(e) => {*/}
                {/*                e.preventDefault();*/}
                {/*                e.stopPropagation();*/}

                {/*                setMode(2);*/}

                {/*                return false;*/}
                {/*            }}>*/}
                {/*                打開掃描*/}
                {/*            </IonButton>*/}
                {/*        </IonCol>*/}
                {/*    </IonRow>*/}
                {/*}*/}
            </IonGrid>
        </IonContent>
    </>;
};
